import { GocooEngineConfig } from '@ktvs8/gocoo-engine-front-end';

/**
 * 実行環境の種別を示したenum
 *
 * 開発環境、テスト環境、本番環境など
 */
export enum EnvironmentType {
  /**
   * ローカル環境で実行
   * バックエンドサーバーは使用しない。モックデータを使用する
   */
  UseMock = 'useMock',
  /**
   * ローカル環境で実行
   * バックエンドサーバーもローカル
   */
  DevelopmentBackendServer = 'developmentBackendServer',
  /**
   * station-dev環境で実行
   *
   * stationの開発環境
   */
  StationDev = 'stationDev',
  /**
   * station-test環境で実行
   *
   * stationのテスト環境
   */
  StationTest = 'stationTest',
  /**
   * ステージング環境で実行
   */
  Staging = 'staging',
  /**
   * 本番稼働中
   */
  Production = 'production',
  /**
   * ユニットテスト実行時の環境
   */
  UnitTest = 'unitTest',
}
/**
 * EnvironmentTypeのユーティリティクラス
 */
export class ApplicationEnvironmentTypeUtility {
  /**
   * 発注先マスタ認証URLを取得
   * @returns
   */
  static getMSupplierVerificationUrl(): string {
    return environmentTypeInfo[GocooEngineConfig.environment.environmentType].mSupplierVerificationUrl;
  }
  /**
   * 受領確認URLを取得
   * @returns
   */
  static getOrdersheetReceivingUrl(): string {
    return environmentTypeInfo[GocooEngineConfig.environment.environmentType].ordersheetReceivingUrl;
  }
  /**
   * 発注先マスタ認証URLを取得
   * @returns
   */
  static getSystemFromEmailAdress(): string {
    return environmentTypeInfo[GocooEngineConfig.environment.environmentType].systemFromEmailAdress;
  }

  /**
   * 発注書の追加送信先を取得
   * @returns
   */
  static getOrdersheetExtraDestinations(): string[] {
    // カンマ区切りで複数のメールアドレスを取得
    const descriptions =
      environmentTypeInfo[GocooEngineConfig.environment.environmentType].ordersheetExtraDestinations.split(',');
    return descriptions.filter((description) => description.trim() !== '');
  }
}

/**
 * ログイン処理が必須となる環境リスト
 */
export const requireLoginEnvironmentTypes: EnvironmentType[] = [
  EnvironmentType.StationDev,
  EnvironmentType.StationTest,
  EnvironmentType.Production,
  EnvironmentType.Staging,
];
/**
 * バックエンドのサーバー情報
 *
 * @description
 * - バックエンドサーバーのURL
 * - ログ出力サーバーのURL
 * - station-headerのURL
 */
export type BackendServerInfoType = {
  /**
   * 発注先マスタ認証URL
   */
  mSupplierVerificationUrl: string;

  /**
   * 発注先マスタ認証URL
   */
  ordersheetReceivingUrl: string;

  /**
   * 認証メールの送信元のメールアドレス
   */
  systemFromEmailAdress: string;

  /**
   * 発注書の追加送信先
   */
  ordersheetExtraDestinations: string;
};

/**
 * 各実行環境の情報を管理したオブジェクト
 */
const environmentTypeInfo: { [key in EnvironmentType]: BackendServerInfoType } = {
  [EnvironmentType.UseMock]: {
    mSupplierVerificationUrl: '',
    ordersheetReceivingUrl: '',
    systemFromEmailAdress: '',
    ordersheetExtraDestinations: '',
  },
  [EnvironmentType.DevelopmentBackendServer]: {
    mSupplierVerificationUrl: '',
    ordersheetReceivingUrl: '',
    systemFromEmailAdress: '',
    ordersheetExtraDestinations: '',
  },
  [EnvironmentType.StationDev]: {
    mSupplierVerificationUrl: 'https://dev.ordersheet-public.dx-station.ktvs8.com/MSupplierVerification',
    ordersheetReceivingUrl: 'https://dev.ordersheet-public.dx-station.ktvs8.com/OrdersheetReceiving',
    systemFromEmailAdress: 'i-fujihara@ktvs.co.jp',
    ordersheetExtraDestinations: '',
  },
  [EnvironmentType.StationTest]: {
    mSupplierVerificationUrl: 'https://test.ordersheet-public.dx-station.ktvs8.com/MSupplierVerification',
    ordersheetReceivingUrl: 'https://test.ordersheet-public.dx-station.ktvs8.com/OrdersheetReceiving',
    systemFromEmailAdress: 'i-fujihara@ktvs.co.jp',
    ordersheetExtraDestinations: '',
  },
  [EnvironmentType.Staging]: {
    mSupplierVerificationUrl: 'https://stg.ordersheet-public.dx-station.ktvs8.com/MSupplierVerification',
    ordersheetReceivingUrl: 'https://stg.ordersheet-public.dx-station.ktvs8.com/OrdersheetReceiving',
    systemFromEmailAdress: 'no-reply@dx-station.ktvs8.com',
    ordersheetExtraDestinations: '769a33ac.ktvs.co.jp@apac.teams.ms,i-fujihara@ktvs.co.jp',
  },
  // 本番環境のURLを設定する
  [EnvironmentType.Production]: {
    mSupplierVerificationUrl: 'https://ordersheet-public.p.ktv.dx-station.com/MSupplierVerification',
    ordersheetReceivingUrl: 'https://ordersheet-public.p.ktv.dx-station.com/OrdersheetReceiving',
    systemFromEmailAdress: 'no-reply@ktv.dx-station.com',
    ordersheetExtraDestinations: 'shitauke-seisaku@ktv.co.jp',
  },
  [EnvironmentType.UnitTest]: {
    mSupplierVerificationUrl: '',
    ordersheetReceivingUrl: '',
    systemFromEmailAdress: '',
    ordersheetExtraDestinations: '',
  },
};
